export default function preScale(img, factor) {
    if(factor > 0.5) {
        return {scaled: false}
    }
    let tmpCanvas = document.createElement('canvas');
    tmpCanvas.width = img.width/2;
    tmpCanvas.height = img.height/2;
    let ctx = tmpCanvas.getContext('2d');
    ctx.drawImage(img, 0, 0, img.width/2, img.height/2);
    let divident = 4;
    while(1/divident > factor*2) {
        //console.log("old size:", img.width/(divident-2), img.height/(divident-2), " new size:", img.width/divident, img.height/divident)
        ctx.drawImage(tmpCanvas, 0, 0, img.width/(divident-2), img.height/(divident-2), 0, 0, img.width/divident, img.height/divident)
        divident += 2;
    }
    return {
        scaled: true,
        canvas: tmpCanvas, 
        w: img.width/(divident-2), 
        h: img.height/(divident-2)
    };
}